"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4471],{

/***/ 24471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Hero_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollToPlugin.js
var ScrollToPlugin = __webpack_require__(39664);
var ScrollToPlugin_default = /*#__PURE__*/__webpack_require__.n(ScrollToPlugin);
;// CONCATENATED MODULE: ./src/components/More/More.tsx





gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollToPlugin_default()));
var More = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: function() {
            return gsap/* default.to */.ZP.to(window, {
                duration: 0,
                scrollTo: {
                    y: "#what_website",
                    offsetY: 0
                }
            });
        },
        className: classnames_default()("hidden lg:flex absolute cursor-pointer bottom-0 right-0 md:left-0 text-red bg-primary h-[200px] items-center justify-center w-[70px]", "_topMoreButton"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "-rotate-90 -translate-y-10 relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("inline-block w-[70px] h-[0.15rem] bg-white -translate-x-full absolute top-1/2 -left-[70%]", "_topMoreButtonLine")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-white text-[14px] inline-block relative top-[1px]",
                    children: "More"
                })
            ]
        })
    });
};
/* harmony default export */ var More_More = (More);

// EXTERNAL MODULE: ./node_modules/gsap/gsap-core.js
var gsap_core = __webpack_require__(25317);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
// EXTERNAL MODULE: ./node_modules/typewriter-effect/dist/react.js
var dist_react = __webpack_require__(5459);
var dist_react_default = /*#__PURE__*/__webpack_require__.n(dist_react);
;// CONCATENATED MODULE: ./src/views/WhatWeDo/components/Hero/Hero.tsx







gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollToPlugin_default()));
function Hero() {
    var tl = gsap/* default.timeline */.ZP.timeline({
        defaults: {
            duration: 1
        }
    });
    var tl1 = gsap/* default.timeline */.ZP.timeline({
        defaults: {
            duration: 1
        }
    });
    var tl2 = gsap/* default.timeline */.ZP.timeline({
        defaults: {
            duration: 1
        }
    });
    var tl3 = gsap/* default.timeline */.ZP.timeline({
        defaults: {
            duration: 1
        }
    });
    var ref = (0,react.useState)(false), isTypeWritterPlay = ref[0], setIsTypeWritterPlay = ref[1];
    var whatWeDoStatus = (0,react.useRef)(null);
    var whatWeDoVideo = (0,react.useRef)(null);
    var heroWhatWeDo = (0,react.useRef)(null);
    var whatWeDoDec = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setIsTypeWritterPlay(true);
        }, 1100);
    }, []);
    (0,react.useEffect)(function() {
        tl.to(whatWeDoStatus.current, {
            ease: gsap_core/* Power2.easeOut */.Lp.easeOut,
            delay: 0.2,
            width: "100%",
            duration: 1.5
        });
        tl1.to(whatWeDoVideo.current, {
            ease: gsap_core/* Power2.easeOut */.Lp.easeOut,
            delay: 0.2,
            "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            duration: 1.5
        });
        tl2.to(heroWhatWeDo.current, {
            x: 0,
            opacity: 1,
            delay: 0.2
        }, "start");
        tl3.to(whatWeDoDec.current, {
            y: 0,
            opacity: 1,
            delay: 0.2
        }, "start");
    }, []);
    var handleScroll = function(id) {
        if (id === 1) {
            gsap/* default.to */.ZP.to(window, {
                duration: 0,
                scrollTo: {
                    y: "#website_desktop",
                    offsetY: 30
                }
            });
        }
        if (id === 2) {
            gsap/* default.to */.ZP.to(window, {
                duration: 0,
                scrollTo: {
                    y: "#desktop_apps",
                    offsetY: 30
                }
            });
        }
        if (id === 3) {
            gsap/* default.to */.ZP.to(window, {
                duration: 0,
                scrollTo: {
                    y: "#desktop_ecom",
                    offsetY: 30
                }
            });
        }
        if (id === 4) {
            gsap/* default.to */.ZP.to(window, {
                duration: 0,
                scrollTo: {
                    y: "#desktop_strategy",
                    offsetY: 30
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative lg:h-[1140px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-0 top-0 w-1/2 h-full hidden lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute left-0 top-0 h-full bg-primary",
                    ref: whatWeDoStatus
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(More_More, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-0 lg:h-full pt-[110px] lg:p-[70px] grid grid-cols-1 lg:grid-cols-[40%,60%]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center px-10 lg:pr-0 lg:pl-[50px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-14",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    ref: heroWhatWeDo,
                                    className: "flex items-center gap-[20px] -translate-x-6 opacity-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-6 h-0.5 bg-primary"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "text-[#131313] font-semibold text-[.92857rem] tracking-[.13286rem]",
                                            children: "SERVICES"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    ref: whatWeDoDec,
                                    className: "opacity-0 translate-y-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "leading-[1.22222em] md:text-[2.57143rem] text-[30px] lg:text-[1.71429rem] xl:text-[2.57143rem] text-[#131313] font-light lg:mt-[3.57143rem] lg:mb-[5.5rem]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex gap-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        className: "font-bold",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_react_default()), {
                                                            options: {
                                                                strings: [
                                                                    "Designing",
                                                                    "Developing",
                                                                    "Improving",
                                                                    "Executing",
                                                                    "Pioneering", 
                                                                ],
                                                                autoStart: isTypeWritterPlay,
                                                                deleteSpeed: 30,
                                                                delay: 70,
                                                                loop: true,
                                                                cursor: ""
                                                            }
                                                        })
                                                    })
                                                }),
                                                " ",
                                                "digital experiences."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-[#4a4a4a] leading-[1.42857em] text-[14px] lg:max-w-[17rem] xl:max-w-[25rem] desktop:max-w-[19.5rem] 2xl:max-w-[23.5rem] 3xl:max-w-[33rem] space-y-6 md:space-y-[20px] lg:mt-10 mt-[5.7rem] mb-[3.57143rem]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Crating ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: " conversion-focused campaigns "
                                                        }),
                                                        " that engage your ideal audience and sky-rocket brand awareness."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "",
                                                    children: [
                                                        "Using a ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: " data-driven approach "
                                                        }),
                                                        " puts the decision-making process of the user at the center of every solution."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: whatWeDoVideo,
                        className: "h-full w-full pl-0 relative hidden lg:block whatWeDoVideo -rotate-180",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:block hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    playsInline: true,
                                    poster: "/images/what_we_do/Whatwedo-background.webp",
                                    className: "w-full absolute top-0 left-0 h-full object-cover rotate-180",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/videos/what_we_do_heroBanner.webm",
                                        type: "video/webm"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 left-0 h-full group-hover:w-14 w-full pl-40 flex items-center rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "space-y-32",
                                    children: constant/* whatWeDoHeroDatas.map */.kC.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "group transition-all duration-[350ms] ease-in-out cursor-pointer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return handleScroll(item.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-0 w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[4.28571rem] leading-[1] text-white font-bold group-hover:scale-[1.8] transition-all duration-[350ms] origin-right ease-in-out mr-[2.85714rem]",
                                                            children: item.number
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-col group-hover:scale-[1.6] transition-all duration-[350ms] ease-in-out origin-left",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "leading-[1.22727em] text-[1.28571rem] font-light text-white m-[0_0_5px]",
                                                                    children: item.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex items-center gap-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                            className: "font-bold text-white text-[.92857rem] leading-5",
                                                                            children: "Discover more"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "h-[2px] bg-white w-12 group-hover:w-14 translate-y-1"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, item.number);
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Hero_Hero = (Hero);


/***/ })

}]);